import { DuckbillDirectoryBannerWeb } from '@frontend/assets';
import { Anchor, Button, ImageBackground, Text, XStack, YStack } from '@frontend/web-react';
import { useAnalytics } from '@frontend/web/hooks';
import { Env } from '@frontend/web/utils';

export const DirectoryCard = () => {
  const { track } = useAnalytics();

  return (
    <YStack accessibilityLabel="Duckbill directory" className="gap-md">
      <Text color="primary" type="h4">
        Want more inspiration?
      </Text>
      {/* eslint-disable-next-line react/jsx-pascal-case */}
      <Anchor
        href={Env.VITE_DUCKBILL_DIRECTORY_URL}
        onClick={() => track({ event: 'directoryBannerSelected', topic: 'examples' })}
      >
        {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
        <ImageBackground className="rounded-lg" source={DuckbillDirectoryBannerWeb}>
          <XStack
            className="px-xl py-lg gap-sm size-full rounded-lg justify-between items-center"
            style={{
              backdropFilter: 'blur(2px)',
              background: 'linear-gradient(180deg, rgba(217, 217, 217, 0.20) 0%, rgba(115, 115, 115, 0.20) 89.3%)',
            }}
          >
            <YStack className="grow-1">
              {/* eslint-disable-next-line tailwindcss/no-arbitrary-value */}
              <Text className="font-[500]" color="primary" type="h1">
                Duckbill directory
              </Text>
              <Text color="primary" type="p-md">
                We created a searchable directory of all our most common tasks.
              </Text>
            </YStack>
            <Button
              leftIconColor="white"
              leftIconName="IconPlus"
              onClick={(e) => {
                e?.stopPropagation();
                track({ event: 'directoryBannerSelected', topic: 'examples' });
                window.open(Env.VITE_DUCKBILL_DIRECTORY_URL, '_blank');
              }}
              variant="gradient"
            >
              View directory
            </Button>
          </XStack>
        </ImageBackground>
      </Anchor>
    </YStack>
  );
};
